/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Insert_Subtitle_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Insert new subtitle event" |
*
* @param {Event_Insert_Subtitle_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_insert_subtitle_aria_label = /** @type {((inputs?: Event_Insert_Subtitle_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Insert_Subtitle_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inserer un nouvel evenement de sous-titre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neues Untertitelereignis einfügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci nuovo evento sottotitolo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить новое событие субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar nuevo evento de subtítulo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入新的字幕事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しい字幕イベントを挿入")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया उपशीर्षक इवेंट डालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir novo evento de legenda")
	return /** @type {LocalizedString} */ ("Insert new subtitle event")
});